const useWhiteBackground = () => {
    const { pathname } = window.location;

    const urls = [
        /employer\/\w{24}\/position\/\w{24}\/wizard\/preliminaryFeedback\/v2/,
        /employer\/\w{24}\/position\/\w{24}\/wizard\/suggestions/,
    ];

    const isWhiteBackground = urls.some((pathRegex) => pathRegex.test(pathname));
    return isWhiteBackground;
};

export default useWhiteBackground;
